import React, { useState, useEffect, useRef } from "react";
import "../Services/Services.css";

const services = [
  {
    id: 1,
    title: "Live Concerts",
    image: "/lc.jpeg",
    overlayColor: "rgba(0, 0, 0, 0.5)",
    icon: "🎤",
  },
  {
    id: 2,
    title: "Corporate Events",
    image: "/coe.jpg",
    overlayColor: "rgba(0, 0, 50, 0.5)",
    icon: "💼",
  },
  {
    id: 3,
    title: "Wedding Events",
    image: "/we.png",
    overlayColor: "rgba(50, 0, 0, 0.5)",
    icon: "💍",
  },
  {
    id: 4,
    title: "Social Events",
    image: "/se.png",
    overlayColor: "rgba(0, 50, 0, 0.5)",
    icon: "🎉",
  },
];

const ServiceItem = ({ service }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let observer;
    if (ref.current) {
      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(ref.current);
          }
        },
        { rootMargin: "100px" } // preload slightly before it appears
      );
      observer.observe(ref.current);
    }
    return () => {
      if (observer && ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <div
      ref={ref}
      className="service-grid-item"
      style={{
        backgroundImage: isVisible ? `url(${service.image})` : "none",
        "--overlay-color": service.overlayColor,
      }}
    >
      <div className="overlay" />
      <div className="particles"></div>
      <div className="content-wrapper">
        <h1>{service.title}</h1>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <div className="services-container">
      <div className="angle-shape"></div>
      <h1 className="hd">
        <div className="hd-line">
          What We Offer <span className="hd-span">{" "}.</span>
        </div>
      </h1>

      {/* Enhanced Glowing Spots */}
      <div className="glow-spot glow-spot-1"></div>
      <div className="glow-spot glow-spot-2"></div>
      <div className="glow-spot glow-spot-3"></div>

      {/* Grid Container with Particles */}
      <div className="services-grid-container">
        {services.map((service) => (
          <ServiceItem key={service.id} service={service} />
        ))}
      </div>
    </div>
  );
};

export default Services;
